import { render, staticRenderFns } from "./PageLockedNotice.vue?vue&type=template&id=74180e6a"
import script from "./PageLockedNotice.vue?vue&type=script&lang=js"
export * from "./PageLockedNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports